import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import g from "../../modal/src/Modal.js";
import { NDialog as k } from "./Dialog.js";
import { dialogProps as m, dialogPropKeys as C } from "./dialogProps.js";
import { keep as v } from "../../_utils/vue/keep.js";
import { defineComponent as p, h } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as b } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { normalizeClass as E } from "../../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const O = Object.assign(Object.assign({}, m), {
  onAfterEnter: Function,
  onAfterLeave: Function,
  transformOrigin: String,
  blockScroll: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  onEsc: Function,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  internalStyle: [String, Object],
  maskClosable: {
    type: Boolean,
    default: !0
  },
  onPositiveClick: Function,
  onNegativeClick: Function,
  onClose: Function,
  onMaskClick: Function,
  draggable: [Boolean, Object]
}), L = p({
  name: "DialogEnvironment",
  props: Object.assign(Object.assign({}, O), {
    internalKey: {
      type: String,
      required: !0
    },
    to: [String, Object],
    // private
    onInternalAfterLeave: {
      type: Function,
      required: !0
    }
  }),
  setup(t) {
    const l = b(!0);
    function a() {
      const {
        onInternalAfterLeave: e,
        internalKey: n,
        onAfterLeave: i
      } = t;
      e && e(n), i && i();
    }
    function s(e) {
      const {
        onPositiveClick: n
      } = t;
      n ? Promise.resolve(n(e)).then((i) => {
        i !== !1 && o();
      }) : o();
    }
    function r(e) {
      const {
        onNegativeClick: n
      } = t;
      n ? Promise.resolve(n(e)).then((i) => {
        i !== !1 && o();
      }) : o();
    }
    function c() {
      const {
        onClose: e
      } = t;
      e ? Promise.resolve(e()).then((n) => {
        n !== !1 && o();
      }) : o();
    }
    function f(e) {
      const {
        onMaskClick: n,
        maskClosable: i
      } = t;
      n && (n(e), i && o());
    }
    function u() {
      const {
        onEsc: e
      } = t;
      e && e();
    }
    function o() {
      l.value = !1;
    }
    function d(e) {
      l.value = e;
    }
    return {
      show: l,
      hide: o,
      handleUpdateShow: d,
      handleAfterLeave: a,
      handleCloseClick: c,
      handleNegativeClick: r,
      handlePositiveClick: s,
      handleMaskClick: f,
      handleEsc: u
    };
  },
  render() {
    const {
      handlePositiveClick: t,
      handleUpdateShow: l,
      handleNegativeClick: a,
      handleCloseClick: s,
      handleAfterLeave: r,
      handleMaskClick: c,
      handleEsc: f,
      to: u,
      maskClosable: o,
      show: d
    } = this;
    return h(g, {
      show: d,
      onUpdateShow: l,
      onMaskClick: c,
      onEsc: f,
      to: u,
      maskClosable: o,
      onAfterEnter: this.onAfterEnter,
      onAfterLeave: r,
      closeOnEsc: this.closeOnEsc,
      blockScroll: this.blockScroll,
      autoFocus: this.autoFocus,
      transformOrigin: this.transformOrigin,
      draggable: this.draggable,
      internalAppear: !0,
      internalDialog: !0
    }, {
      default: ({
        draggableClass: e
      }) => h(k, Object.assign({}, v(this.$props, C), {
        titleClass: E([this.titleClass, e]),
        style: this.internalStyle,
        onClose: s,
        onNegativeClick: a,
        onPositiveClick: t
      }))
    });
  }
});
export {
  L as NDialogEnvironment,
  O as exposedDialogEnvProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/DialogEnvironment.js
// module id = 1634
// module chunks = 41